<div class="container-fluid p-2 mt-3">

    <!-- TOP BAR: FILTERS + SUMMARY -->
    <div class="row g-2 align-items-center mb-3 dashboard-top-bar">

        <div class="date-filters">
            <!-- DATE FILTERS -->
            <div class="col-md-2">
                <label class="small-label">Start Date</label>
                <p-calendar [(ngModel)]="filters.start_date" dateFormat="dd/mm/yy" styleClass="clean-date" [showIcon]="true"></p-calendar>
            </div>

            <div class="col-md-2">
                <label class="small-label">End Date</label>
                <p-calendar [(ngModel)]="filters.end_date" dateFormat="dd/mm/yy" styleClass="clean-date" [showIcon]="true"></p-calendar>
            </div>

            <div class="col-md-3 d-flex gap-2 align-items-end">
                <button
                    pButton
                    label="Generate"
                    icon="pi pi-search"
                    class="view-button-success"
                    (click)="loadReport()">
                </button>

                <button
                    pButton
                    label="Excel"
                    icon="pi pi-file-excel"
                    class="excel-button-success"
                    [disabled]="!report?.daily_breakdown?.length"
                    (click)="exportCollections()">
                </button>
            </div>
        </div>

        <!-- PRIMARY CARDS -->
        <div class="row g-2 mb-2">
            <div class="col-md-2">
                <div class="summary-card blue">
                    <i class="pi pi-calendar"></i>
                    <div>
                        <div class="label">Appointments</div>
                        <div class="value">{{ report.summary.total_appointments }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-2">
                <div class="summary-card green">
                    <i class="pi pi-file"></i>
                    <div>
                        <div class="label">Fees Generated</div>
                        <div class="value">₹{{ report.summary.fees_generated }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-2">
                <div class="summary-card green">
                    <i class="pi pi-wallet"></i>
                    <div>
                        <div class="label">Total Collected</div>
                        <div class="value">₹{{ report.summary.total_collected }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-2">
                <div class="summary-card green">
                    <i class="pi pi-money-bill"></i>
                    <div>
                        <div class="label">Cash Collected</div>
                        <div class="value">₹{{ report.summary.cash_collected }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-2">
                <div class="summary-card green">
                    <i class="pi pi-credit-card"></i>
                    <div>
                        <div class="label">Online Collected</div>
                        <div class="value">₹{{ report.summary.online_collected }}</div>
                    </div>
                </div>
            </div>

            <div class="col-md-2">
                <div class="summary-card orange">
                    <i class="pi pi-clock"></i>
                    <div>
                        <div class="label">Pending</div>
                        <div class="value">₹{{ report.summary.total_pending }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- DAILY TABLE -->
    <div class="inventory-table-card">
        <div class="table-header">
            <div class="header-cell">DATE</div>
            <div class="header-cell">PATIENTS</div>
            <div class="header-cell">FEES</div>
            <div class="header-cell">CASH</div>
            <div class="header-cell">ONLINE</div>
            <div class="header-cell">TOTAL</div>
            <div class="header-cell">PENDING</div>
            <div class="header-cell">DRILL</div>
        </div>

        <div class="table-body">
            <div *ngFor="let day of report.daily_breakdown" class="table-row">
                <div class="table-cell">{{ day.collection_date }}</div>
                <div class="table-cell">{{ day.patients }}</div>
                <div class="table-cell">₹{{ day.fees }}</div>
                <div class="table-cell">₹{{ day.cash }}</div>
                <div class="table-cell">₹{{ day.online }}</div>
                <div class="table-cell">₹{{ day.total }}</div>
                <div class="table-cell">₹{{ day.pending }}</div>
                <div class="table-cell">
                    <button pButton label="View" class="view-button" (click)="openDailyDetails(day)">
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- DAILY PATIENT DETAILS -->
    <p-dialog header="Collections Details - {{ selectedDate }}" [(visible)]="visibleModal" [modal]="true"
        [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">

        <div class="inventory-table-card">
            <div class="dialog-table-header">
                <div class="header-cell">PATIENT</div>
                <div class="header-cell">FEES</div>
                <div class="header-cell">CASH</div>
                <div class="header-cell">ONLINE</div>
                <div class="header-cell">TOTAL RECEIVED</div>
                <div class="header-cell">PENDING</div>
            </div>

            <div class="table-body">
                <div *ngFor="let p of dailyDetails" class="dialog-table-row">
                    <div class="table-cell">{{ p.patient_name }}</div>
                    <div class="table-cell">₹{{ p.visit_fees }}</div>
                    <div class="table-cell">₹{{ p.received_cash }}</div>
                    <div class="table-cell">₹{{ p.received_online }}</div>
                    <div class="table-cell">₹{{ p.total_received }}</div>
                    <div class="table-cell">₹{{ p.pending }}</div>
                </div>
            </div>
        </div>

        <div class="text-end mt-2 d-flex justify-content-end gap-2">
            <button
                pButton
                label="Export Excel"
                icon="pi pi-file-excel"
                class="excel-button-success"
                (click)="exportDailyPatientDetails(selectedDate)">
                <!-- (click)="test(selectedDate)"> -->
            </button>

            <button pButton label="Close" class="close-button-success" (click)="visibleModal=false"></button>
        </div>

    </p-dialog>

</div>
